var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00390625H513V341.989H0V-0.00390625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 170.993V341.989H0V170.993H256.5Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 -0.00390625V170.992H256.5V-0.00390625H513Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25 37.7666L140.097 74.2267H178.435L147.419 96.7616L159.265 133.222L128.25 110.688L97.2343 133.222L109.08 96.7616L78.0649 74.2267H116.403L128.25 37.7666Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.75 208.763L396.597 245.223H434.935L403.919 267.758L415.765 304.218L384.75 281.684L353.734 304.218L365.58 267.758L334.565 245.223H372.903L384.75 208.763Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPa);
export default __webpack_public_path__ + "static/media/PA.0571842da239d760de4c93c353aac06b.svg";
export { ForwardRef as ReactComponent };